/**
 * timezones — curated IANA timezone list (SPR-009 P2-6).
 *
 * A reasonable curated set (US zones first, then common worldwide zones) for the
 * profile timezone dropdown. Values are IANA identifiers (e.g.
 * "America/Chicago"); labels add a friendly city/region name.
 */
export const TIMEZONES = [
  { value: "America/New_York", label: "Eastern Time (America/New_York)" },
  { value: "America/Chicago", label: "Central Time (America/Chicago)" },
  { value: "America/Denver", label: "Mountain Time (America/Denver)" },
  { value: "America/Phoenix", label: "Arizona (America/Phoenix)" },
  { value: "America/Los_Angeles", label: "Pacific Time (America/Los_Angeles)" },
  { value: "America/Anchorage", label: "Alaska (America/Anchorage)" },
  { value: "Pacific/Honolulu", label: "Hawaii (Pacific/Honolulu)" },
  { value: "America/Toronto", label: "Toronto (America/Toronto)" },
  { value: "America/Mexico_City", label: "Mexico City (America/Mexico_City)" },
  { value: "America/Sao_Paulo", label: "São Paulo (America/Sao_Paulo)" },
  { value: "Europe/London", label: "London (Europe/London)" },
  { value: "Europe/Dublin", label: "Dublin (Europe/Dublin)" },
  { value: "Europe/Paris", label: "Paris (Europe/Paris)" },
  { value: "Europe/Berlin", label: "Berlin (Europe/Berlin)" },
  { value: "Europe/Madrid", label: "Madrid (Europe/Madrid)" },
  { value: "Europe/Rome", label: "Rome (Europe/Rome)" },
  { value: "Europe/Amsterdam", label: "Amsterdam (Europe/Amsterdam)" },
  { value: "Europe/Athens", label: "Athens (Europe/Athens)" },
  { value: "Europe/Moscow", label: "Moscow (Europe/Moscow)" },
  { value: "Asia/Dubai", label: "Dubai (Asia/Dubai)" },
  { value: "Asia/Kolkata", label: "India (Asia/Kolkata)" },
  { value: "Asia/Singapore", label: "Singapore (Asia/Singapore)" },
  { value: "Asia/Hong_Kong", label: "Hong Kong (Asia/Hong_Kong)" },
  { value: "Asia/Shanghai", label: "Shanghai (Asia/Shanghai)" },
  { value: "Asia/Tokyo", label: "Tokyo (Asia/Tokyo)" },
  { value: "Asia/Seoul", label: "Seoul (Asia/Seoul)" },
  { value: "Australia/Sydney", label: "Sydney (Australia/Sydney)" },
  { value: "Pacific/Auckland", label: "Auckland (Pacific/Auckland)" },
  { value: "UTC", label: "UTC" },
];
